import * as React from "react"
import { type EntityTransaction, Flow } from "@digits-graphql/frontend/graphql-bearer"
import { LoadingBlock } from "@digits-shared/components/Loaders"
import { CopyableAmount } from "@digits-shared/DesignSystem/CopyableAmount"
import numberHelper, { CurrencyStyle } from "@digits-shared/helpers/numberHelper"
import stringHelper from "@digits-shared/helpers/stringHelper"
import { FlowAmount } from "src/frontend/components/Shared/Transactions/TableCells/FlowAmount"

export const AmountCell: React.FC<{ transaction: EntityTransaction }> = ({ transaction }) => {
  const { isNormal, businessFlow, value } = transaction.moneyFlow
  const isZero = value.amount === 0

  const classNames = stringHelper.classNames(
    businessFlow === Flow.Inbound ? "inbound" : "outbound",
    isNormal || isZero ? "normal" : "abnormal",
    !isNormal && !isZero && "negative"
  )

  return (
    <CopyableAmount amount={transaction.moneyFlow} $variant="absolute">
      <FlowAmount className={classNames}>
        <b>{numberHelper.currency(value, { style: CurrencyStyle.Detail, absolute: true })}</b>
      </FlowAmount>
    </CopyableAmount>
  )
}

export const LoadingAmountCell: React.FC = () => <LoadingBlock width="100%" height="20px" />
